// Duolingo gold: #FFD900

export default function Progress(theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          height: 10,
          overflow: 'hidden',
          backgroundColor: theme.palette.grey[200]
        },
        bar: {
          borderRadius: 999,
          backgroundColor: '#FFD900'
        },
        colorPrimary: {
          backgroundColor: theme.palette.grey[isLight ? 200 : 700],
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#FFD900'
          }
        },
        colorSecondary: {
          backgroundColor: theme.palette.grey[isLight ? 200 : 700],
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.secondary.main
          }
        },
        buffer: {
          backgroundColor: 'transparent'
        }
      }
    }
  };
}
